import { FileOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { documentsApi } from '@api/documents/documentsApi';
import type { IBtlDocument } from '@api/documents/types';
import { openBlobInNewTab } from '@pages/ApplicationDetailsPage/helpers';
import { DocumentTypeEnum } from '@legacy/shared-types/enums/document-type.enum';
import { formatDateTimeLondonNoTz } from '@utils/dates';

export interface ICustomerFilesListItemProps {
  document: IBtlDocument;
}

const DOCUMENT_TYPE_LABEL: Record<string, string> = {
  [DocumentTypeEnum.BANK_STATEMENT]: 'Bank statement',
  [DocumentTypeEnum.PROOF_OF_INCOME]: 'Proof of income',
  [DocumentTypeEnum.PROOF_OF_DEPOSIT]: 'Proof of deposit',
  [DocumentTypeEnum.OTHER]: 'Other',
};

function getDocumentTypeLabel(type: string): string {
  return DOCUMENT_TYPE_LABEL[type] ?? type;
}

export const CustomerFilesListItem = ({ document }: ICustomerFilesListItemProps) => {
  const handleViewClick = () => {
    documentsApi.getBtlFileById(document.id).then(res => {
      openBlobInNewTab(res, document.originalFileName);
    });
  };

  return (
    <Flex
      align='center'
      justify='space-between'
      className='h-16 max-h-16 shrink-0 overflow-hidden rounded-lg bg-slate-50 px-4 py-2'
    >
      <Flex align='center' className='min-w-0 flex-1 gap-3'>
        <div className='flex size-8 shrink-0 items-center justify-center'>
          <FileOutlined className='h-[18px] w-[18px] shrink-0' />
        </div>
        <Flex vertical className='min-w-0 flex-1 gap-0.5'>
          <Typography.Text
            className='truncate text-sm font-semibold leading-5 text-black'
            title={document.originalFileName}
          >
            {document.originalFileName}
          </Typography.Text>
          <Flex className='min-w-0 gap-1 overflow-hidden'>
            <Typography.Text className='shrink-0 text-xs font-medium leading-4 text-green-600'>
              {getDocumentTypeLabel(document.type)}
            </Typography.Text>
            <Typography.Text className='shrink-0 text-xs font-medium leading-4 text-gray-400'>•</Typography.Text>
            <Typography.Text className='truncate text-xs font-medium leading-4 text-gray-400'>
              {formatDateTimeLondonNoTz(document.createdAt)}
            </Typography.Text>
          </Flex>
        </Flex>
      </Flex>
      <Button
        type='default'
        className='ml-3 h-6 w-11 shrink-0 rounded-3xl border border-gray-200 bg-white px-2 text-xs font-normal leading-5 text-black/90 shadow-none'
        onClick={handleViewClick}
      >
        View
      </Button>
    </Flex>
  );
};
